<template>
  <div id="app">
    <router-view v-if="!isInitLoading" />
    <v-app v-else>
      <v-container fluid>
        <v-card>
          <v-card-text>
            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-container>
    </v-app>
  </div>
</template>

<script>
export default {
  data: () => ({
    isInitLoading: true
  }),
  async created () {
    await this.$store.dispatch('GET_CURRENCIES')
    this.isInitLoading = false
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue